import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  divider: {
    width: '100%',
  },
  spaced: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  statusBox: {
    alignItems: 'center',
    display: 'flex',
    margin: theme.spacing(0.5),
  },
  monitorPlaceTitleContainer: {
    paddingBottom: theme.spacing(1),
    textAlign: 'center',
    width: '100%',
  },
  statusDescription: {
    fontSize: '0.85em',
    fontStyle: 'italic',
    marginLeft: theme.spacing(2),
  },
  imageContainer: {
    position: 'relative',
    '&.MuiCard-root': {
      borderRadius: theme.shape.borderRadius,
      margin: 0,
      marginBottom: theme.spacing(0.5),
      marginTop: theme.spacing(1),
      padding: 0,
    }
  },
  input: {
    display: "none",
    width: "40%",
  },
  inputField: {
    left: theme.spacing(0.5),
    position: 'absolute',
    top: theme.spacing(0.5),
    display:'flex',
    '& .MuiIconButton-root': {
      backgroundColor: theme.palette.blue.lightest,
      borderRadius: '30%',
    },
  },
  textFormat:{
    fontWeight:300,
    fontSize:18,
    lineHeight:'21.09px',
    alignItems:'center'
  },
  socialControlLabel: {
    '& .MuiTypography-body1': {
      fontSize: '0.9rem',
    },
  },
  dialogActions: {
    alignItems: 'center',
    display: 'flex',
    flex: '0 0 auto',
    justifyContent: 'center',
    marginTop: theme.spacing(3),
    padding: theme.spacing(1),
  },
  defaultActions: {
    marginTop: theme.spacing(3),
    textAlign: 'center',
  },
  marginBottom: {
    marginBottom: theme.spacing(3),
  },
  bottomButtons: {
    marginTop: theme.spacing(3),
  },
  button: {
    color: theme.palette.text.title,
    marginTop: theme.spacing(0.5),
  },
  cardMedia: {
    backgroundColor: theme.palette.blue.lightest,
    height: 133,
  },
}));
